// This function is for when javascript needs access to the custom tailwindcss color set currently in use based on municipality
// (primary map for example)
export function getTailwindColorHex(color) {
  try {
    // Access the computed styles of the root element to get the primary css variable
    const municipality = useCookie('municipality');
    const user = useState('user');
    let themeStyles;

    // Fetch the theme styles if a color set is selected, based on municipality
    if (municipality.value && user.value?.use_municipality_branding) {
      // Fetch the theme styles based on the selected municipality
      const themeElement = document.querySelector(`.${municipality.value}`);
      themeStyles = getComputedStyle(themeElement);
    }
    else {
      // Fetch the theme styles based on the root element (default)
      themeStyles = getComputedStyle(document.documentElement);
    }

    // Fetch the color
    const colorValue = themeStyles.getPropertyValue(`${color}`).trim();

    // If it's already a hex value, return it
    if (colorValue.startsWith('#')) {
      return colorValue;
    }

    // Otherwise, convert from RGB to hex
    const rgbValues = colorValue.match(/\d+/g).join(' '); // "rgb(255, 0, 0)" => "255 0 0"
    return rgbToHex(rgbValues);
  }
  catch (error) {
    console.error('Error getting tailwind color hex:', error);
    return '#000000';
  }
}